export default __webpack_public_path__ + "static/media/716.2fcc2483.gif";